export default "__VITE_ASSET__BbSPHIeW__"